/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HideCaseFileUpdate
 */
export interface HideCaseFileUpdate {
    /**
     * 
     * @type {string}
     * @memberof HideCaseFileUpdate
     */
    caseFileId: string;
    /**
     * 
     * @type {boolean}
     * @memberof HideCaseFileUpdate
     */
    isHidden: boolean;
}

export function HideCaseFileUpdateFromJSON(json: any): HideCaseFileUpdate {
    return HideCaseFileUpdateFromJSONTyped(json, false);
}

export function HideCaseFileUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): HideCaseFileUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'caseFileId': json['caseFileId'],
        'isHidden': json['isHidden'],
    };
}

export function HideCaseFileUpdateToJSON(value?: HideCaseFileUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'caseFileId': value.caseFileId,
        'isHidden': value.isHidden,
    };
}


